import React, { useEffect, useRef, useState } from "react";
import "./IntegrationAppDetails.scss";
import {
  AssessmentButton,
  Bullets,
  RightSidePanel,
  showToast,
  SkeletonList,
  Tooltip,
} from "ui-components";
import { t } from "i18next";
import {
  capitalizeFirstLetter,
  copyToClipboard,
  maskClientId,
  removeFromQueryParams,
} from "../../../../utils/Common/Constant";
import CopyVector from "../../../../utils/Images/CopyVector";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import DownArrow from "../../../../utils/Images/DownArrow";
import AppCreation from "../AppCreation/AppCreation";
import {
  getDetailsIntegrations,
  integrationDelete,
} from "../../../../service/Settings/Settings";
import HideIcon from "../../../../utils/Images/HideIcon";
import VisibleIcon from "../../../../utils/Images/VisibleIcon";
import beautify from "js-beautify";
import DownloadIcon from "../../../../utils/Images/DownloadIcon";
import { SettingAppEnums } from "../../../../utils/Enums/SettingAppEnums";
import DataNotAvailable from "../../../../utils/DataNotFound/DataNotAvailable";
interface IntegrationAppDetailsProps {
  getAppList: any;
}
const IntegrationAppDetails = ({ getAppList }: IntegrationAppDetailsProps) => {
  const [appDetails, setAppDetails] = useState<any>(null);
  const urlRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [editIntegrationModal, setEditIntegrationModal] = useState(false);
  const [renderDetails, setRenderDetails] = useState(0);
  const [show, setShow] = useState(false);
  const [showClientId, setShowClientId] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const integrationId = searchParams.get("at");
  const toggleVisibility = () => {
    setShowClientId((prev) => !prev);
  };

  const clientId = appDetails?.app_data?.clientId || "";
  // App Detail list APi
  useEffect(() => {
    if (integrationId) {
      getAppDetails();
    } else {
      setAppDetails([]);
    }
  }, [integrationId, renderDetails]);
  const getAppDetails = async () => {
    setIsLoading(true);
    const getApp: any = await getDetailsIntegrations(integrationId ?? "");
    if (getApp?.status === 200) {
      setAppDetails(getApp?.data);
      setIsLoading(false);
    }
  };
  const handleClosePopup = () => {
    setShow(false);
  };

  // Delete integration
  const handleDeleteIntegration = async (clientId: string) => {
    try {
      const response = await integrationDelete(clientId);
      if (response?.status === 200) {
        showToast(response?.customMessage, "success");
        handleClosePopup();
        getAppList();
        removeFromQueryParams(queryParams, "at", navigate);
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };
  // Css code fornatting
  const rawCss = appDetails?.app_data?.style || "";
  const formattedCss = beautify.css(
    rawCss
      .replace(/<style>/gi, "") // remove opening tag
      .replace(/<\/style>/gi, ""), // remove closing tag
    { indent_size: 2 },
  );

  // Download button
  const handleDownload = () => {
    const blob = new Blob([formattedCss.trim()], { type: "text/css" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "style.css";
    link.click();
  };
  return (
    <>
      <div className="integrationWrapper">
        {isLoading ? (
          <>
            {Array.from({ length: 5 }).map((_, index) => (
              <SkeletonList
                key={`skeleton-${index}`}
                numberOfTitles={1}
                numberofTextLines={0}
                titleSize={18}
                textSize={12}
                thumbnailHeight={80}
                thumbnailWidth={50}
                itemsGap={20}
              />
            ))}
          </>
        ) : appDetails?.app_data ? (
          <>
            <div className="enablePannelBtn">
              <div className="careerHead">
                <h3>{appDetails?.app_data?.appName}</h3>
              </div>
              <div className="d-flex gap-2">
                <AssessmentButton
                  className="lightBtn"
                  onClick={() => {
                    setEditIntegrationModal(true);
                  }}
                >
                  {t("GENERAL.EDIT")}
                </AssessmentButton>

                {/* Modal */}
                <AssessmentButton
                  className="lightBtn"
                  onClick={() => setShow(true)}
                >
                  {t("GENERAL.DELETE")}
                </AssessmentButton>
                <CustomModal
                  show={show}
                  handleClose={handleClosePopup}
                  isHeaderVisible={false}
                  isCrossBtn={true}
                  isFooterVisible={false}
                >
                  <div className="deleteIntegrationModal d-flex flex-column align-items-center">
                    <h5>{t("SETTING.CONFIRM_DELETE_INTEGRATION")}</h5>
                    <div className="d-flex gap-3 mt-3">
                      <AssessmentButton
                        onClick={() =>
                          handleDeleteIntegration(
                            appDetails?.app_data?.clientId,
                          )
                        }
                      >
                        {t("GENERAL.YES")}
                      </AssessmentButton>
                      <AssessmentButton onClick={() => setShow(false)}>
                        {t("GENERAL.NO")}
                      </AssessmentButton>
                    </div>
                  </div>
                </CustomModal>
              </div>
            </div>
            {editIntegrationModal && (
              <RightSidePanel
                show={true}
                handleClose={() => {
                  setEditIntegrationModal(false);
                }}
                title={t("GENERAL.INTEGRATIONS")}
                className="integrationModal"
              >
                <AppCreation
                  dataForEdit={appDetails?.app_data}
                  setEditIntegrationModal={setEditIntegrationModal}
                  setRenderDetails={setRenderDetails}
                  getAppList={getAppList}
                />
              </RightSidePanel>
            )}
            {/* Domain */}
            <div className="domainsSec">
              <div className="copyScript">
                <div className="integrationSubHead">
                  <h2>{t("SETTING.ALLOWED_DOMAIN")}</h2>
                </div>
                <div className="domainsSecBullets ">
                  {appDetails?.app_data?.domain?.map(
                    (item: any, ind: number) => {
                      return (
                        <div className="domainBulletBtn" key={ind}>
                          <Bullets skillName={capitalizeFirstLetter(item)} />
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            </div>

            {/* Client */}
            <div className="copyScript">
              <div className="integrationSubHead clientIdHead">
                <h2>{t("SETTING.CLIENT_ID")}</h2>
                <Tooltip text="Used in Integration Method 2" />
              </div>
              <div className="scriptFieldSec">
                <div className="scriptField">
                  <p
                    ref={urlRef}
                    title={t("SETTING.CLIENT_ID")}
                    className={showClientId ? "" : "hiddenClientId"}
                  >
                    {maskClientId(clientId, showClientId)}
                  </p>
                  <span
                    onClick={toggleVisibility}
                    style={{ cursor: "pointer" }}
                  >
                    {showClientId ? <HideIcon /> : <VisibleIcon />}
                  </span>
                </div>
                <div className="d-flex gap-2">
                  <div className="cursorPointer" title={t("SETTING.CLIENT_ID")}>
                    <AssessmentButton
                      className="lightBtn"
                      onClick={() =>
                        copyToClipboard(
                          urlRef,
                          appDetails?.app_data?.clientId,
                          t("SETTING.COPY_CLIENT_ID"),
                        )
                      }
                    >
                      <CopyVector />
                    </AssessmentButton>
                  </div>
                </div>
              </div>
            </div>

            {/* Features */}
            <div className="featureList">
              <div className="featureAccord">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        {t("SETTING.CAREER_PAGE")}
                        <DownArrow />
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        {/* Tabs Section */}
                        <div className="careerTabs">
                          <div className="tab-content" id="nav-tabContent">
                            {/* Division */}
                            <div className="row">
                              <div className="col-lg-6">
                                <h4 className="methodHeading">
                                  {t("SETTING.METHOD_1")}
                                </h4>
                                <div className="methodOne">
                                  <div className="secHeight">
                                    <div className="stepsContent">
                                      <div className="stepDiv mb-0 mt-3">
                                        <h6>
                                          {t("SETTING.STEP_1_COPY_THE_SCRIPT")}
                                        </h6>
                                        <p>{t("SETTING.COPY_THE_PROVIDED")}</p>
                                      </div>
                                    </div>
                                    <div className="stepsContent">
                                      <div className="stepDiv mb-0 mt-4">
                                        <h6> {t("SETTING.JAVASCRIPT")}</h6>
                                      </div>
                                    </div>
                                    <div className="codeTab">
                                      <h6>
                                        <div className="d-flex">
                                          <div className="copyStyleBtn">
                                            <AssessmentButton
                                              className="lightBtn"
                                              onClick={() =>
                                                copyToClipboard(
                                                  urlRef,
                                                  appDetails?.Job_templates
                                                    ?.HTML_Script,
                                                  t("SETTING.COPY_SCRIPT"),
                                                )
                                              }
                                            >
                                              <CopyVector />
                                            </AssessmentButton>
                                          </div>
                                        </div>
                                        <pre>
                                          <code>
                                            {
                                              appDetails?.Job_templates
                                                ?.HTML_Script
                                            }
                                          </code>
                                        </pre>
                                      </h6>
                                    </div>

                                    <div className="stepsContent">
                                      <div className="stepDiv mb-0 mt-4">
                                        <h6>{t("SETTING.STYLE")}</h6>
                                      </div>
                                    </div>
                                    <div className="codeTab styleSection">
                                      <h6>
                                        <div className="d-flex">
                                          <div className="copyStyleBtn">
                                            <AssessmentButton
                                              className="lightBtn"
                                              onClick={() =>
                                                copyToClipboard(
                                                  urlRef,
                                                  appDetails?.app_data?.style,
                                                  t("SETTING.COPY_STYLE"),
                                                )
                                              }
                                            >
                                              <CopyVector />
                                            </AssessmentButton>
                                          </div>
                                          <div className="downloadStyleBtn">
                                            <AssessmentButton
                                              className="lightBtn "
                                              onClick={handleDownload}
                                            >
                                              <DownloadIcon />
                                            </AssessmentButton>
                                          </div>
                                        </div>

                                        <pre>
                                          <code>{formattedCss}</code>
                                        </pre>
                                      </h6>
                                    </div>
                                    <div className="stepsContent">
                                      <div className="stepDiv">
                                        <h6>
                                          {t("SETTING.STEP_2_PASTE_THE_SCRIPT")}
                                        </h6>
                                        <p>
                                          {t(
                                            "SETTING.PASTE_THE_COPIED_SCRIPT_TAG",
                                          )}
                                        </p>
                                        <h6>
                                          {t("SETTING.ADD_THE_CSS_IN_ONE")}
                                        </h6>

                                        <ul>
                                          <li>
                                            {t("SETTING.INSIDE_A_STYLE_TAG")}
                                          </li>
                                          <li>
                                            {t("SETTING.INSIDE_A_LINK_TAG")}
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="stepDiv">
                                        <h6>
                                          {t("SETTING.STEP_3_SAVE_AND_PREVIEW")}
                                        </h6>
                                        <p>
                                          {t("SETTING.SAVE_THE_UPDATE_HTML")}
                                        </p>
                                      </div>
                                      <div className="stepDiv shadowLeft mb-0">
                                        <h5 className="fsSma">
                                          {t("SETTING.AVAILABLE_FILTERS")}
                                        </h5>
                                        <ul>
                                          <li>
                                            <span className="highlightSpan">
                                              {t("SETTING.DATA_PAGE_SIZE")}
                                            </span>
                                            - {t("SETTING.DEFAULT_IS")}
                                            <span className="highlightSpan">
                                              10
                                            </span>
                                            {t("SETTING.SET_TO_ANY_NUMBER")}
                                          </li>
                                          <li>
                                            {" "}
                                            <span className="highlightSpan">
                                              {t(
                                                "SETTING.DATA_ENGAGEMENT_TYPE",
                                              )}
                                            </span>{" "}
                                            – {t("SETTING.DEFAULT_IS")}{" "}
                                            <span className="highlightSpan">
                                              {t("VENDOR.ALL")}
                                            </span>
                                            . {t("SETTING.USE")}{" "}
                                            <span className="highlightSpan">
                                              {t("SETTING.FULLTIME")}
                                            </span>
                                            ,{" "}
                                            <span className="highlightSpan">
                                              {t("SETTING.PARTTIME")}
                                            </span>
                                            ,{" "}
                                            <span className="highlightSpan">
                                              {t("SETTING.CONTRACT")}
                                            </span>
                                            ,{" "}
                                            <span className="highlightSpan">
                                              {t("SETTING.INTERNSHIP")}
                                            </span>{" "}
                                            {t(
                                              "SETTING.TO_SHOW_SPECIFIC_JOB_TYPE",
                                            )}
                                          </li>
                                          <li>
                                            {" "}
                                            <span className="highlightSpan">
                                              {t("SETTING.DATA_JOB_TYPE")}
                                            </span>{" "}
                                            – {t("SETTING.DEFAULT_IS")}{" "}
                                            <span className="highlightSpan">
                                              {t("VENDOR.ALL")}
                                            </span>
                                            . {t("SETTING.USE")}{" "}
                                            <span className="highlightSpan">
                                              {t("SETTING.ONSITE")}
                                            </span>
                                            ,
                                            <span className="highlightSpan">
                                              {t("SETTING.HYBRID")}
                                            </span>
                                            ,
                                            <span className="highlightSpan">
                                              {t("SETTING.REMOTE")}
                                            </span>{" "}
                                            {t(
                                              "SETTING.TO_SHOW_SPECIFIC_WORK_STYLES",
                                            )}
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <h4 className="methodHeading">
                                  {t("SETTING.METHOD_2_TOKEN_BASED")}
                                </h4>
                                <div className="methodTwo">
                                  <div className="secHeight">
                                    <div className="note shadowLeft">
                                      <h6>{t("SETTING.PREREQUISITES")}</h6>
                                      <ul>
                                        <li>
                                          <span>
                                            {t("SETTING.CLIENT_ID")}:{" "}
                                          </span>
                                          {t("SETTING.VISIBLE_AT_THE_TOP")}
                                        </li>
                                        <li>
                                          <span>
                                            {t("SETTING.CLIENT_SECRET")}:{" "}
                                          </span>
                                          {t(
                                            "SETTING.VISIBLE_ONLY_DURING_INTEGRATION",
                                          )}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="note">
                                      <h6>
                                        {t(
                                          "SETTING.STEP_1_GENERATE_ACCESS_TOKEN",
                                        )}
                                      </h6>
                                      <h6>{t("SETTING.ENDPOINT")}:</h6>
                                      <div className="linkBgColor">
                                        {SettingAppEnums.CLIENT_TOKENS_GET}
                                      </div>
                                    </div>
                                    <div className="note">
                                      <h6>{t("SETTING.HEADERS")}:</h6>
                                      <div className="linkBgColor">
                                        <span>
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                SettingAppEnums.CLIENT_TOKENS_HEADERS,
                                            }}
                                          />
                                        </span>
                                      </div>
                                    </div>

                                    <div className="note smNote">
                                      <h6>
                                        {t(
                                          "SETTING.HOW_TO_ENCODE_CLIENT_CREDENTIALS",
                                        )}
                                        :
                                      </h6>
                                      <ul>
                                        <li>
                                          {t("SETTING.CONCATENATE_CLIENT_ID")}:
                                          <p>{t("SETTING.CLIENT_SECRET_SM")}</p>
                                        </li>
                                        <li>
                                          {t(
                                            "SETTING.ENCODE_THE_RESULT_IN_BASE64",
                                          )}
                                          <p>
                                            {t("SETTING.ECHO_N_BASE64_ENCODED")}
                                          </p>
                                        </li>
                                        <li>
                                          {t("SETTING.USE_THE_RESULT_AS")}:
                                          <p className="directionLtr">
                                            {t(
                                              "SETTING.AUTHORIZATION_BASIC_BASE64",
                                            )}
                                          </p>
                                        </li>
                                      </ul>
                                    </div>

                                    <div className="note">
                                      <h6>{t("SETTING.EXAMPLE_CURL")}:</h6>
                                      <div className="linkBgColor">
                                        <span>
                                          {SettingAppEnums.CLIENT_TOKENS_CURL}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="note">
                                      <h6>
                                        {t("SETTING.STEP_2_CALL_JOB_LIST")}
                                      </h6>
                                      <p>
                                        {t("SETTING.USE_THE_TOKEN_RECIVED")}
                                      </p>
                                    </div>
                                    <div className="note">
                                      <h6>{t("SETTING.EXAMPLE_CURL")}:</h6>
                                      <div className="linkBgColor">
                                        <span>
                                          {SettingAppEnums.JOB_LIST_CURL}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="note shadowLeft">
                                      <h6>{t("SETTING.NOTES")}:</h6>
                                      <h5 className="fsSma">
                                        {t(
                                          "SETTING.AVAILABLE_FILTERS_OPTIONAL",
                                        )}
                                        :
                                      </h5>
                                      <ul>
                                        <li>
                                          {t(
                                            "SETTING.REPLACE_BASE64_ENCODED_CLIENT_ID",
                                          )}
                                        </li>
                                        <li>
                                          {t(
                                            "SETTING.TO_GET_THE_JSON_RESPONSE",
                                          )}
                                        </li>
                                        <li>{t("SETTING.TOKEN_EXPIRES_IN")}</li>
                                        <li>{t("SETTING.ALWAYS_USE_HTTPS")}</li>
                                        <li>
                                          <span className="highlightSpan">
                                            {t("SETTING.DATA_PAGE_SIZE")}
                                          </span>
                                          - {t("SETTING.DEFAULT_IS")}{" "}
                                          <span className="highlightSpan">
                                            10
                                          </span>
                                          {t("SETTING.SET_TO_ANY_NUMBER")}
                                        </li>
                                        <li>
                                          {" "}
                                          <span className="highlightSpan">
                                            {t("SETTING.DATA_JOB_TYPE")}
                                          </span>{" "}
                                          - {t("SETTING.DEFAULT_IS")}{" "}
                                          <span className="highlightSpan">
                                            {t("VENDOR.ALL")}
                                          </span>
                                          . {t("SETTING.USE")}{" "}
                                          <span className="highlightSpan">
                                            {t("SETTING.FULLTIME")}
                                          </span>
                                          ,{" "}
                                          <span className="highlightSpan">
                                            {t("SETTING.PARTTIME")}
                                          </span>
                                          ,{" "}
                                          <span className="highlightSpan">
                                            {t("SETTING.CONTRACT")}
                                          </span>
                                          ,{" "}
                                          <span className="highlightSpan">
                                            {t("SETTING.INTERNSHIP")}
                                          </span>{" "}
                                          {t(
                                            "SETTING.TO_SHOW_SPECIFIC_JOB_TYPE",
                                          )}
                                        </li>
                                        <li>
                                          {" "}
                                          <span className="highlightSpan">
                                            {t("SETTING.DATA_ENGAGEMENT_TYPE")}
                                          </span>{" "}
                                          – {t("SETTING.DEFAULT_IS")}{" "}
                                          <span className="highlightSpan">
                                            {t("VENDOR.ALL")}
                                          </span>
                                          {t("SETTING.USE")}{" "}
                                          <span className="highlightSpan">
                                            {t("SETTING.ONSITE")}
                                          </span>
                                          ,
                                          <span className="highlightSpan">
                                            {t("SETTING.HYBRID")}
                                          </span>
                                          ,
                                          <span className="highlightSpan">
                                            {t("SETTING.REMOTE")}
                                          </span>{" "}
                                          {t(
                                            "SETTING.TO_SHOW_SPECIFIC_WORK_STYLES",
                                          )}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="col-md-12">
            <div className="noCareer">
              <DataNotAvailable text={t("SETTING.NO_INTEGRATION_MESSAGE")} />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default IntegrationAppDetails;
